import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { lookupM365AppDefinition } from '../M365AppDefinitionService';
/**
 * Make call to Teams MT service
 */
export var fetchAppDefinitionsFromAppsService = function () { return __awaiter(void 0, void 0, void 0, function () {
    var context, appDefinitions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchOfficeComponentContext()];
            case 1:
                context = _a.sent();
                return [4 /*yield*/, lookupM365AppDefinition({
                        officeComponentContext: context,
                    })];
            case 2:
                appDefinitions = _a.sent();
                return [2 /*return*/, appDefinitions];
        }
    });
}); };
//# sourceMappingURL=fetchAppDefinitionsFromAppsService.js.map